import { Component, OnInit, Input, inject } from '@angular/core';
import { NotifierService } from 'angular-notifier';
// import { NotifierNotificationOptions } from 'angular-notifier/lib/models/notifier-notification.model';
import { InjectedData } from 'src/app/core/services/global-handler.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { status } from '@shared/heplers/const-data';
import { LocalizedDatePipe } from '../../../pipes/localized-date.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { NgClass } from '@angular/common';
import { NotifierNotificationOptions } from 'node_modules/angular-notifier/lib/models/notifier-notification.model';

@Component({
    selector: 'app-c-notification',
    templateUrl: './c-notification.component.html',
    styleUrls: ['./c-notification.component.scss'],
    imports: [NgClass, TranslateModule, LocalizedDatePipe]
})
export class CNotificationComponent implements OnInit {
  private notifierService = inject(NotifierService);


  @Input() notification: NotifierNotificationOptions;

  notificationTime = new Date();
  message = {} as InjectedData
  icon: string
  readonly status = status;
  bsModalRef: BsModalRef;

  ngOnInit() {
    this.setIcon(this.notification.type);
    this.message = JSON.parse(this.notification.message);
  }

  close() {
    this.notifierService.hide(this.notification.id);
  }

  setIcon(type) {
    switch (type) {
      case status.INFO:
        this.icon = 'fa fa-info'
        break;
      case status.SUCCESS:
        this.icon = 'fa fa-check'
        break;
      case status.WARNING:
        this.icon = 'fa fa-exclamation'
        break;
      case status.ERROR:
        this.icon = 'fa fa-exclamation-circle'
        break;

      default:
        this.icon = ''
        break;
    }
  }

}
